/**
 * Canonical domain enums, replacing per-repo duplicates:
 *  - cars-finder-api/app/models/ai_analysis.py (DamageSeverity,
 *    InvestmentRecommendation, AnalysisStatus)
 *  - cars-finder-web/src/features/cars/types/car.ts (DamageSeverity)
 *  (PriceConfidenceLevel was removed with the OpenAI generator, 2026-10-05.)
 *  - cars-finder-web/src/features/bids/types/bid.ts (BidStatus)
 *
 * Const objects + same-named union types (not TS `enum`) so values survive
 * package boundaries, `isolatedModules`, and verbatim embedding into the web
 * artifact. `DamageSeverity.MINIMAL` keeps working exactly as before.
 *
 * DEPENDENCY-FREE on purpose: embedded verbatim into the generated web artifact.
 */
/** Extensible auction-source discriminator (autach/wom/autobid land in phase 15). */
export const DataSource = {
    ALPICAR: 'alpicar',
    AUTACH: 'autach',
    WOM: 'wom',
    AUTOBID: 'autobid',
};
/** NB: `NONE` exists in the Python model but was missing from the web copy. */
export const DamageSeverity = {
    NONE: 'none',
    MINIMAL: 'minimal',
    LIGHT: 'light',
    MODERATE: 'moderate',
    SEVERE: 'severe',
    TOTAL_LOSS: 'total_loss',
};
export const InvestmentRecommendation = {
    EXCELLENT: 'excellent',
    GOOD: 'good',
    FAIR: 'fair',
    POOR: 'poor',
    AVOID: 'avoid',
};
export const AnalysisStatus = {
    SUCCESS: 'success',
    FAILED: 'failed',
    NOT_FOUND: 'not_found',
    PENDING: 'pending',
    IN_PROGRESS: 'in_progress',
};
/**
 * `dealer` is reserved for phase 14 (dealer accounts); no code grants it yet.
 * Role checks stay `role.includes('admin')` — see api-node roles.guard.ts.
 */
export const UserRole = {
    ADMIN: 'admin',
    STAFF: 'staff',
    USER: 'user',
    DEALER: 'dealer',
};
/**
 * Bid lifecycle. Display strings ARE the stored values (legacy decision).
 * Legacy statuses ('Cancelled', 'Lost', delivery statuses) are normalized by
 * web's normalizeBidStatus() — the contract only admits the 4 canonical values.
 */
export const BidStatus = {
    Active: 'Under Review',
    Outbid: 'Outbid',
    Cancelled: 'Not Won',
    Won: 'Won',
};
//# sourceMappingURL=car-enums.js.map